export default __webpack_public_path__ + "media/vue/img/whence/whence-logo-1e75282000f2a70c5d7e5dbc6b25ce48.png";